/**
 * Created by Allan on 2022/08/03.
 * Contact 84880528@qq.com.
 * 全局路由
 */
import Vue from 'vue'
import Router from 'vue-router'
// 导入各模块路由配置
import Login from './map/login';  //登录
import Order from './map/order';  //订单
import Peruorder from "./map/peruorder";  //秘鲁订单页面

import Product from "./map/product";

Vue.use(Router)
const routes=[
    /*...Login,*/
    ...Order,
    ...Peruorder,
    ...Product,
];
export default new Router({
    /*mode:'history',*/
    routes
})
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/repayment/router/index.js